import { Command } from "./Command";
import { HistoryEventHandler } from "../history";
import { removeElementFromListMap } from "../svgtransformlist";
import { isNullish } from "../utilities";

/**
* History command for an element removed from the DOM.
* @implements {module:history.HistoryCommand}
*/
export class RemoveElementCommand extends Command {
    public parent: Element;
    public nextSibling: Node;

    /**
    * @param {SVGElement} elem - The removed DOM element
    * @param {Node} oldNextSibling - The DOM element's nextSibling when it was in the DOM
    * @param {Element} oldParent - The DOM element's parent
    * @param {string} [text] - An optional string visible to user related to this change
    */
    constructor(elem: SVGElement, oldNextSibling: Node, oldParent: Element, text?: string) {
        super();
        this.elem = elem;
        this.text = text || ('Delete ' + elem.tagName);
        this.nextSibling = oldNextSibling;
        this.parent = oldParent;

        // special hack for webkit: remove this element's entry in the svgTransformLists map
        removeElementFromListMap(elem);
    }

    /**
    * Re-removes the new element.
    * @param {module:history.HistoryEventHandler} handler
    * @fires module:history~Command#event:history
    * @returns {void}
    */
    apply(handler: HistoryEventHandler) {
        super.apply(handler, () => {
            removeElementFromListMap(this.elem);
            this.parent = this.elem.parentNode as Element;
            this.elem.remove();
        });
    }

    /**
    * Re-adds the new element.
    * @param {module:history.HistoryEventHandler} handler
    * @fires module:history~Command#event:history
    * @returns {void}
    */
    unapply(handler: HistoryEventHandler) {
        super.unapply(handler, () => {
            removeElementFromListMap(this.elem);
            if (isNullish(this.nextSibling) && window.console) {
                console.error('Reference element was lost');
            }
            this.parent.insertBefore(this.elem, this.nextSibling); // Don't use `before` or `prepend` as `this.nextSibling` may be `null`
        });
    }
}

